import { useState, useEffect } from 'react';

const useWindowWidth = () => {
  const getAdjustedWidth = () => window.innerWidth * 0.9;

  const [width, setWidth] = useState(getAdjustedWidth());

  useEffect(() => {
    const handleResize = () => {
      setWidth(getAdjustedWidth());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
}

export default useWindowWidth;